const actions = {
  SET_STATE: 'messagebox/SET_STATE',
  SEND_FEEDBACK: 'messagebox/SEND_FEEDBACK',
  SET_MESSAGE: 'messagebox/SET_MESSAGE',
  FETCH_FEEDBACK: 'messagebox/FETCH_FEEDBACK'
}

export default actions
